import { authHeader, handleResponse } from '../helpers';
export const MobileUserTDSReportService = {
    fetchTDSData
};

function fetchTDSData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetUserTDSreportExport`, requestOptions)
        .then(handleResponse);
}